var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRightSquare2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4 34.2L34.9029 28.6971C35.8402 27.7598 35.8402 26.2402 34.9029 25.3029L29.4 19.8M34.2 27L17.4 27M39 51H15C8.37258 51 3 45.6274 3 39V15C3 8.37258 8.37258 3 15 3H39C45.6274 3 51 8.37258 51 15V39C51 45.6274 45.6274 51 39 51Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRightSquare2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/right-square-2.475460ebb9348f0373f68d494d1a654b.svg";